exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fade-enter-active[data-v-31e8c027],.fade-leave-active[data-v-31e8c027]{transition:opacity .3s}.fade-enter[data-v-31e8c027],.fade-leave-to[data-v-31e8c027]{opacity:0}.wfeTitle[data-v-31e8c027]{color:purple;text-decoration:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-31e8c027","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/App.vue
// module id = 152
// module chunks = 0